<template>
    <div class="multiple__choice--wrapper" :class="'multiple__choice--wrapper-'+index">
        <div class="multiple__choice__text">
            <slot name="text"></slot>
        </div>
        <div class="multiple__choice--answers">
            <template v-for="(a,ind) in answers[0]" >
                <div class="answer" data-value="false"  :class="'answer-'+ind" v-on:click="selectAnswer(ind)" v-if="a.value == false" v-html="a.text">

                </div>
                <div class="answer" data-value="true"  :class="'answer-'+ind" v-on:click="selectAnswer(ind)" v-if="a.value == true" v-html="a.text">

                </div>
            </template>

        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: "MultipleChoice",
        props:{
            answers: Array,
            index: Number
        },
        methods: {
            selectAnswer(ind){
                let item = $('.multiple__choice--wrapper-'+ this.index + ' .answer-'+ind);
                if($(item).hasClass('selected')){
                    $(item).removeClass('selected');
                    $(item).removeClass('wrong');
                    $(item).removeClass('right');
                } else {
                    $(item).addClass('selected');
                    let val = $(item).attr('data-value');
                    if(val == 'false'){
                        $(item).addClass('wrong');
                    } else {
                        $(item).addClass('right');
                    }
                }

            }
        }
    }
</script>

<style scoped>

</style>